import { Injectable } from '@angular/core';
import { ESG } from '../interfaces/esg.interfaces';
import { Observable, catchError, map, of, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { EsgJson } from '../pages/esg/esg.json';

@Injectable({
  providedIn: 'root'
})
export class EsgService {

  endpointApi = environment.apiCMSEsg
  endpointApiRetalk = environment.apiCmsRetalk
  endpointApiCasos = environment.apiCmsCasos
  endpointApiTeam = environment.apiCmsTeam

  esgContent: any;

  constructor(private http: HttpClient) { }
  // Handle API errors =================================
  handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('An client error occurred:', error.error.message);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong,
      console.log("Backend error code " + error.status + ", body was: " + JSON.stringify(error.error));
    }
    // return an observable with a user-facing error message
    return throwError(() => error.error)
  }

  getEsg() {
    this.esgContent = this.http.get<any>(this.endpointApi + '/get?id=1')
      .pipe(
        map(resp => {
          return resp.data.esg;
        }),
        catchError(this.handleError)
      )
    return this.esgContent
    // return EsgJson;
  }
}
